// extracted by mini-css-extract-plugin
export var socialIcon = "styles-module--socialIcon--61aba";
export var socialIcons = "styles-module--socialIcons--e75ab";